import { notification, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import axios from "axios";
import { CustomSpinner, CustomTable } from "../utils/CustomComponents";
const { Text } = Typography;
/**
 ** Options header (columns)
 */
const columns = [
	{
		title: "Date",
		dataIndex: "date",
		key: "date",
		render: (value) => {
			return <Text strong>{value}</Text>;
		},
	},
	{
		title: "Customer",
		dataIndex: "customer",
		key: "customer",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Type",
		dataIndex: "type",
		key: "type",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Prospection Type",
		dataIndex: "prospectionType",
		key: "prospectionType",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Contact Global",
		dataIndex: "contactGlobal",
		key: "contactGlobal",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Created By",
		dataIndex: "user",
		key: "user",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
];

const TaskType = ({ type, seller }) => {
	const [loading, setLoading] = useState(true);
	const [historyTasks, setHistoryTasks] = useState([]);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		getCustomers();
	}, []);

	const getCustomers = async () => {
		setLoading(true);
		let url = api + `/customertask/get/list/sellertype/${seller}/${type}`;

		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item, index) => {
					list.push({
						index: index,
						customer: `${item.customer.customerNumber} ${item.customer.name}`,
						type: item.type,
						prospectionType: item.prospectionType || "-",
						contactGlobal: item.contactGlobal,
						date: new Intl.DateTimeFormat("en-US", {
							month: "numeric",
							year: "numeric",
							day: "numeric",
							hour: "2-digit",
							minute: "2-digit",
							second: "2-digit",
						}).format(new Date(item.createdAt)),
						user: item.createdBy.name,
					});
				});
				setHistoryTasks(list);
				setLoading(false);
			} else {
				openNotification("warning", "Warning", data.message);
			}
			setLoading(false);
		} catch (err) {
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const CustomForm = () => {
		return (
			<CustomTable columns={columns} data={historyTasks} isScroll={false} />
		);
	};

	return (
		<div>
			{contextHolder}
			{loading ? <CustomSpinner /> : <CustomForm />}
		</div>
	);
};

export default TaskType;
